module.exports = __webpack_public_path__ + "static/media/post-excerpt-overlay.256984c6.png";